import React from 'react';
import i18next from 'i18next';
import { Spinner, Wrapper } from './wrapper';
import { SrOnly } from '../SrOnly';

interface Props {
  inline?: boolean;
  center?: boolean;
}

const Loader = ({ inline, center }: Props) => (
  <Wrapper inline={inline} center={center}>
    <SrOnly>{i18next.t('other.loading')}</SrOnly>
    <Spinner aria-hidden="true" />
  </Wrapper>
);

export default Loader;
